import { createSelector } from 'reselect';

// STATE SELECTORS
const flash = state => state.admin.flash;

export const flashMessageSelector = createSelector(flash, flash => flash.message);
export const flashTypeSelector = createSelector(flash, flash => flash.flashType);
